import { FlowContextSme } from '../context';
import { EnergyType } from '../types';

export const shouldSkipWhenOnlyWarmth = (context: FlowContextSme): boolean => {
  const { energyType } = context;

  return energyType === EnergyType.Warmth || energyType === EnergyType.WarmthAndTapWater;
};
